module.exports = __webpack_public_path__ + "img/sd_iso_mobile_dark.a14bcf3a.webp";